import React, { useEffect, useState } from "react";
import { Box, Button, Stack, useMediaQuery, useTheme } from "@mui/material";
import ListingTable from "./listing";
import BasicBreadcrumbs from "../../components/breadcrumb";
import PrivateLayout from "../../layouts/privateLayout";
import { Link, useLocation } from "react-router-dom";
import { Add } from "@mui/icons-material";
import { useApiClient } from "../../context/ApiClientContext";
import axios from "axios";
import ErrorAlert from "../../helper/errorAlert";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import api from "../../helper/baseApi";
import ComponentBackdrop from "../../components/backdrop";
import ConfirmDialog from "../../helper/confirmDialog";

export const DataContext = React.createContext();

function Index() {
  const location = useLocation();
  
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPage, setTotalPage] = React.useState();
  const [pageSize, setPageSize] = React.useState();
  const [filteredDataList, setFilteredDataList] = React.useState([]);
  const [showButton, setShowButton] = React.useState(false);
  const [selectedIds, setSelectedIds] = React.useState([]);
  const [selectedRows, setRows] = React.useState([]);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);

  const {
    apiUrls: { mobileApiUrl },
  } = useApiClient();
  const navigate = useNavigate();

const handleOpenConfirm = () => {
    if (selectedIds.length === 0) {
      toast.warning("Please select at least one department to delete.");
      return;
    }
    setOpenConfirm(true);
  };

  const handleCloseConfirm = () => setOpenConfirm(false);

  const handleShowButton = (ids) => {
    setSelectedIds(ids);
    setShowButton(ids.length > 0);
  };

  const fetchDataAndUpdateList = async (page) => {
    try {

      const response = await api.get(`${mobileApiUrl}reward/reward-listing-portal`);
      const  campaign  = response.data.data.rewardList;
      console.log('camp',response);
      
      const dataWithKeys = campaign.map((item) => ({
        ...item,
        id: item.rewardId
      }));      
      setFilteredDataList(dataWithKeys);
    } catch (error) {
      if (error?.response?.status === 404) {
        setFilteredDataList([]);
      } else {
        console.error("An error occurred:", error?.response?.statusText);
      }
    }
  };

  const handleConfirmDelete = async () => {
      setOpenBackdrop(true);
      try {
        const apiUrl = `${mobileApiUrl}campaign/delete`;

        const response = await api.delete(apiUrl, {
          data: { ids: selectedIds }
        });
  
        if (response.status === 200) {
          const deletedItems = filteredDataList.filter(item =>
            selectedIds.includes(item.id)
          );
          const deletedNames = deletedItems.map(item => item.name);
  
          toast.success(`Deleted: ${deletedNames.join(", ")}`);
  
          setFilteredDataList(prev =>
            prev.filter(item => !selectedIds.includes(item.id))
          );
          setSelectedIds([]);
        } else {
          toast.error("Failed to delete campaign. Please try again.");
        }
      } catch (error) {
        console.error("Delete Error:", error);
        ErrorAlert(error, navigate);
      } finally {
        setOpenBackdrop(false);
        setOpenConfirm(false);
      }
    };

  const handleDelete = async () => {
    try {
      const apiUrl = `${mobileApiUrl}campaign/delete`;

      const response = await api.delete(apiUrl, {
        data: { ids: selectedIds }
      });

      if (response.status === 200) {
       setTimeout(() => {
        setOpenBackdrop(false);
  
          const deletedNames = filteredDataList
            .filter(item => selectedIds.includes(item.id))
            .map(item => item.name)
            .join(", ");
          toast.success(`Campaign "${deletedNames}" deleted.`);
        
        setFilteredDataList(prev =>
          prev.filter(item => !selectedIds.includes(item.id))
        );
        setSelectedIds([]);
        setShowButton(false);
      }, 4000);
      }
    } catch (error) {
      if (error.status === 404 || error.status === 400) {
        toast.error("Something went wrong.");
      }
    }
  };

  useEffect(() => {
    fetchDataAndUpdateList();
  }, [location.pathname]);

  return (
    <PrivateLayout>
      <Box sx={{ mx: "40px", mt: 5 }}>
        <ComponentBackdrop openBackdrop={openBackdrop} />
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 2,
          }}
        >
          <BasicBreadcrumbs first="Campaign" />

          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            sx={{
              width: { xs: "100%", sm: "auto" },
              alignItems: { xs: "stretch", sm: "flex-start" },
            }}
          >
            {/* <Link to="/create-event" style={{ textDecoration: "none" }}>
              <Button
                variant="contained"
                size="medium"
                startIcon={<Add />}
                fullWidth={isMobile}
                sx={{
                  backgroundColor: "secondary.main",
                  fontWeight: "600",
                  "&:hover": { backgroundColor: "secondary.dark" },
                  whiteSpace: "nowrap",
                }}
              >
                Add New Event
              </Button>
            </Link> */}

            {showButton && (
              <Button
                variant="contained"
                size="medium"
                fullWidth={isMobile}
                sx={{
                  backgroundColor: "secondary.main",
                  fontWeight: "600",
                  "&:hover": { backgroundColor: "secondary.dark" },
                  whiteSpace: "nowrap",
                }}
                onClick={handleOpenConfirm}
              >
                Delete
              </Button>
            )}

            <ConfirmDialog
              open={openConfirm}
              onClose={handleCloseConfirm}
              onConfirm={handleConfirmDelete}
              title="Delete Department"
              message={`Are you sure you want to delete ${selectedIds.length > 1 ? "these departments" : "this department"
                }?`}
              items={filteredDataList
                .filter(item => selectedIds.includes(item.id))
                .map(item => item.name)}
              confirmText="Delete"
              confirmColor="error"
            />
            
          </Stack>
        </Box>
        <DataContext.Provider value={filteredDataList}>
          <ListingTable
            currentPage={currentPage}
            totalPage={totalPage}
            pageSize={pageSize}
            handleShowButton={handleShowButton}
          />
        </DataContext.Provider>

      </Box>
    </PrivateLayout>
  );
}

export default Index;
